module.exports = __webpack_public_path__ + "img/location__kws.cf74a6d0.svg";